import { Button, Row } from "antd";
import { IAttachment } from "../../../../../types/Attachment";
import { FileOutlined, DownloadOutlined } from "@ant-design/icons";
import { useDownloadFile } from "../../../../../lib/hooks/useDownloadFIle";
import { useCallback, useState } from "react";
import { MessagesService } from "../../../../../services/messages";

type AttachmentListProps = {
  conversationId: string;
  items: IAttachment[] | undefined;
};

export const AttachmentList = ({
  conversationId,
  items,
}: AttachmentListProps) => {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const { download } = useDownloadFile(setIsDownloading);

  const onDownload = useCallback(
    (file: IAttachment) => {
      setIsDownloading(true);

      const request: any = {
        conversationId,
        attachmentId: file.id,
      };

      download(MessagesService, request, file.fileName);
    },
    [download, conversationId]
  );

  return (
    <Row className="d-block">
      {items &&
        items.map((file: IAttachment) => (
          <Row
            key={file.id}
            className="pa-4 justify-space-between attachment mb-2"
          >
            <Row className="align-center">
              <FileOutlined className="mr-3 text" />
              {file.fileName}
            </Row>
            <Button
              disabled={isDownloading}
              id={file.id}
              type="text"
              icon={<DownloadOutlined className="text-sm title" />}
              className="py-0"
              onClick={() => onDownload(file)}
            />
          </Row>
        ))}
    </Row>
  );
};
